import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getScheduleUpdatedBySelector } from '../../../redux/slices/ganttSlice.js';
import MemberAvatar from '../MemberAvatar/MemberAvatar.tsx';
import { type Member } from '../../../assets/js/collaborative_space';
import { Colors } from '../../../constants/colors.constants.js';
import { PencilIcon, SaveIcon } from '../../../icons/Icons.jsx';
import './MemberPreviewTooltip.scss';

interface MemberPreviewTooltipProps {
  member: Member;
  scheduleUpdatedBy: {
    member: Member | null;
    updatedAt: Date | null;
  };
}

const MemberPreviewTooltip = ({
  member,
  scheduleUpdatedBy
}: MemberPreviewTooltipProps) => {
  const { t } = useTranslation();
  const { fullName, email, role, isEditing } = member.profileData;

  return (
    <div className="member-preview-tooltip">
      <div className="member-preview-tooltip__profile">
        <div className="member-preview-tooltip__avatar">
          <MemberAvatar member={member} size={58} />
        </div>
        <div className="member-preview-tooltip__info">
          <div className="member-preview-tooltip__role">
            {t(`positions.${role}`)}
          </div>
          <div className="member-preview-tooltip__name">{fullName}</div>
          <div className="member-preview-tooltip__email">{email}</div>
        </div>
      </div>
      {isEditing && (
        <div className="member-preview-tooltip__actions member-preview-tooltip__actions--editing">
          <PencilIcon color={Colors.BLUE} />
          <div>{t('master_plan.schedule_user_editing')}</div>
        </div>
      )}
      {scheduleUpdatedBy.member?.connectionId === member.connectionId && (
        <div className="member-preview-tooltip__actions member-preview-tooltip__actions--updated">
          <SaveIcon color={Colors.RED} />
          <div>{t('master_plan.schedule_user_updated')}</div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  scheduleUpdatedBy: getScheduleUpdatedBySelector(state)
});

export default connect(mapStateToProps)(MemberPreviewTooltip);
